import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faFolder } from "@fortawesome/free-regular-svg-icons";

import "./archive.css";

import { faGithub } from "@fortawesome/free-brands-svg-icons";

import Fade from "react-reveal/Fade";

const archiveProjects = [
  {
    title: "Natours",
    description:
      "A single page static website for Helping you to decide your next nature's tour, built with Sass and fully Responsive",
    technologies: ["Sass", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-natours.netlify.app/",
    },
  },
  {
    title: "Trillo",
    description:
      "A single page multi purpose static website built with modern flexbox and latest css features alongside with media queries for responsiveness.",
    technologies: ["Flexbox", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-trillo.netlify.app/",
    },
  },
  {
    title: "Portfolio Template",
    description:
      "A portfolio static site built with the most modern web design techniques and technologies, including Grid system and flexbox for layout and responsiveness.",
    technologies: ["Grid", "Flexbox", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-portfolio.netlify.app/",
    },
  },
  {
    title: "Hangman Game",
    description:
      "Hangman game build with vanilla javascript, with not a fancy UI designed with Html and css",
    technologies: ["Javascript", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-hangman.netlify.app/",
    },
  },
  {
    title: "Spock Rock",
    description:
      "Rock paper scissor lizard game build with vanilla javascript, and a simple UI build with Html and css",
    technologies: ["Javascript", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-spock-rock.netlify.app/",
    },
  },
  {
    title: "Math Sprint",
    description:
      "Math sprint game is using the vanilla javascript time events and random equations generator algorithms",
    technologies: ["Javascript", "Css", "Html"],
    links: {
      github: "",
      webpage: "https://afghancoder-math-sprint.netlify.app/",
    },
  },
];

const Archive = () => {
  return (
    <div className="archive-container text-center">
      <div className="about-title text-center">Other Noteworthy Projects</div>
      {/* <span className="color-primary font-family-class">02. </span> */}
      <div className="row justify-content-center gx-3 gy-3">
        {archiveProjects.map((project) => {
          return (
            <div
              className="col-sm-12 col-md-6 col-lg-4 text-center archive-project_card--wrapper"
              key={project.title}
            >
              <Fade bottom>
                <div className=" archive-project_card ">
                  <div className="d-flex align-items-center justify-content-between p-3">
                    <FontAwesomeIcon
                      icon={faFolder}
                      className="archive-project_card--icon"
                    />
                    <div className="archive-project_card--links">
                      {project.links.github !== "" && (
                        <a
                          href={project.links.github}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <FontAwesomeIcon
                            icon={faGithub}
                            className="archive-project_card--link"
                          />
                        </a>
                      )}
                      {project.links.webpage !== "" && (
                        <a
                          href={project.links.webpage}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <FontAwesomeIcon
                            icon={faUpRightFromSquare}
                            className="archive-project_card--link"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                  <span className="color-secondary font-family-class archive-project_card--title">
                    {project.title}
                  </span>
                  <p className="color-tertiary archive-project_card--paragraph">
                    {project.description}
                  </p>
                  <ul className="archive-list font-family-class">
                    {project.technologies.map((tech) => {
                      return <li key={tech}>{tech}</li>;
                    })}
                  </ul>
                </div>
              </Fade>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Archive;
